/**
 * @generated SignedSource<<05bc7f951849587f140df5586913dd19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type groupRulesTab_QueryFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "groupRulesTab_QueryFragment";
};
export type groupRulesTab_QueryFragment$key = {
  readonly " $data"?: groupRulesTab_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupRulesTab_QueryFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "groupRulesTab_QueryFragment"
};

(node as any).hash = "7f2b2c32454cc3bc56c9957f6bdd16ee";

export default node;
